<template>
  <div class="flex flex--col">
    <div class="flex slot-time align-center">
      <p class="text-14 fw-500">{{'Date' | translate}}: {{date}}</p>
      <div class="time-divider"></div>
      <p class="text-14 fw-500">{{'Time' | translate}}: {{time}}</p>
      <div v-if="price > 0" class="time-divider"></div>
      <p v-if="price > 0" class="text-14 fw-500">{{'Price' | translate}}: {{price}} {{currency}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'bkSlot',
    props: ['date', 'time', 'price', 'currency']
  }
</script>

<style lang="less">
  @import '../../less/redesign/base';
  .align-center {
    align-items: center;
  }
  .gap {
    gap: 12px
  }
  .slot-time {
    gap: 5px;
    flex: none;
  }
  .time-divider {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #0f0f0f;
    align-self: center;
  }
  @media screen and (max-width: 650px){
    .align-center {
      align-items: initial;
    }
    .slot-time {
      flex-direction: column;
    }
    .time-divider {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tbooking-widget/Slot.vue